import { ButtonGroup, ElementsWrapper } from '@renderer-ui-library/molecules'
import { Media } from '@renderer-ui-library/molecules/Media/Media'
import { Container, Typography } from '@renderer-ui-library/mui'
import { BlockWrapper } from '@renderer-ui-library/scaffolding/BlockWrapper/BlockWrapper'
import { BlockProps } from 'blocks/BlockProps'
import classNames from 'classnames'
import React from 'react'
import { ICoverBlockData } from './ICoverBlockData'
import styles from './coverBlock.module.scss'

export const CoverBlock: React.FC<BlockProps<ICoverBlockData>> = React.memo(
  (props) => {
    const textColor = props.data.colorOverlay === 'dark' ? 'white' : undefined

    return (
      <BlockWrapper
        blockData={props.data}
        noSpacingTop
        noSpacingBottom
        fullWidth={props.rank === 0 && !props.data.narrow}
      >
        <div className={styles.wrapper}>
          {props.data.media && (
            <div className={styles.mediaWrapper}>
              <Media
                media={props.data.media}
                ratio='original'
                autoPlayVideo
                autoPlaySlideshow
                cover={true}
              />
            </div>
          )}

          <div
            className={classNames(styles.contentWrapper, {
              [styles.colorOverlayDark]: props.data.colorOverlay === 'dark',
              [styles.colorOverlayBright]: props.data.colorOverlay === 'bright',
              [styles.narrow]: props.rank !== 0 || props.data.narrow,
            })}
          >
            <Container maxWidth='lg'>
              <ElementsWrapper className={styles.elementsWrapper}>
                <div>
                  <Typography
                    variant='h1'
                    color={textColor}
                    gutterBottom={!!props.data.subtitle}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    {props.data.title}
                  </Typography>
                  {props.data.subtitle && (
                    <Typography
                      className={styles.subtitle}
                      variant='h4'
                      component='p'
                      color={textColor}
                    >
                      {props.data.subtitle}
                    </Typography>
                  )}
                </div>
                <ButtonGroup
                  primaryButton={props.data.buttonPrimary}
                  secondaryButton={props.data.buttonSecondary}
                />
              </ElementsWrapper>
            </Container>
          </div>
        </div>
      </BlockWrapper>
    )
  }
)

CoverBlock.displayName = 'CoverBlock'
